import { useContext } from 'react';
import { LessonAssignmentContext } from './LessonAssignmentProvider';
import { UseLessonAssignment } from './types';

const useLessonAssignment = (): UseLessonAssignment => {
  const [state, dispatch] = useContext(LessonAssignmentContext);

  return [state, dispatch];
};

export default useLessonAssignment;
